// src/components/RoleBadge.jsx
export function RoleBadge({ role, size = 40 }) {
  if (role?.logo) {
    return (
      <img src={role.logo} alt={role.shortName}
        style={{ width:size, height:size, borderRadius:size*0.22, objectFit:"contain", background:"#fff", padding:2, flexShrink:0 }} />
    );
  }
  return (
    <div style={{
      width:size, height:size, borderRadius:size*0.22, flexShrink:0,
      background: role?.accentBg || "rgba(45,212,191,0.1)",
      border: `1.5px solid ${(role?.accent || "#2DD4BF")}44`,
      display:"flex", alignItems:"center", justifyContent:"center",
      fontSize:size*0.32, fontWeight:800, color:role?.accent||"#2DD4BF",
      letterSpacing:"-0.02em", userSelect:"none"
    }}>{role?.initials || "?"}</div>
  );
}
